import $ from 'jquery';
import { getViewedIDs } from '../../sections/recently-viewed/RecentlyViewed';

export const SELECTOR_ACCOUNT_CONATINER = '[data-account-dropdown-container]';
const SEL_RECENTLY_VIEWED = '[data-recently-viewed]';
export const HEADER_CONTAINER_SELECTOR = '[data-header-container]';
export const CLASS_ACCOUNT_BACKGROUND = 'is-account-menu-open';

export class AccountDropdown {
  constructor() {

    this.headerContainer = $(HEADER_CONTAINER_SELECTOR);

    this.headerContainer.on('mouseenter', SELECTOR_ACCOUNT_CONATINER, e => this.onHoverMenu(e));
    this.headerContainer.on('mouseleave', SELECTOR_ACCOUNT_CONATINER, e => this.onUnhoverMenu(e));

    if(getViewedIDs().length) {
      this.headerContainer.find(SEL_RECENTLY_VIEWED).addClass('is-visible');
    }
  }

  onHoverMenu(e) {
    if(this.timeout) clearTimeout(this.timeout);
    this.headerContainer.addClass(CLASS_ACCOUNT_BACKGROUND);
  }

  onUnhoverMenu(e) {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.headerContainer.removeClass(CLASS_ACCOUNT_BACKGROUND);
    }, 200);
  }
}

$(document).ready($(SELECTOR_ACCOUNT_CONATINER).each((e, i) => new AccountDropdown($(i))));
